import { useState } from "react";

export default function useLocationPicker() {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLocationData, setSelectedLocationData] = useState(null);

  const openLocationPicker = () => {
    setIsOpen(true);
  };

  const closeLocationPicker = () => {
    setIsOpen(false);
  };

  const handleLocationSelect = (locationData) => {
    setSelectedLocationData(locationData);
    setIsOpen(false);
  };

  return {
    isOpen,
    selectedLocationData,
    openLocationPicker,
    closeLocationPicker,
    handleLocationSelect,
    setSelectedLocationData,
  };
}
